import * as district from 'src/api/district'
import {
  GET_ALL_DISTRICT,
  GET_DISTRICT_TO,
  GET_DISTRICT_FROM,
  SET_LOADED_DISTRICT_BY_CITY_CODE
} from 'src/store/mutation-types'

const getAllDistrict = ({commit, dispatch, state}, params) => {
  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(GET_ALL_DISTRICT, state.districtsByCityCode[params.city_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_DISTRICT, response.data)
        if (params.city_code) {
          commit(SET_LOADED_DISTRICT_BY_CITY_CODE, {city_code: params.city_code, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_DISTRICT, [])
      }
    })
  }
}

const getAllDistrictTo = ({commit, dispatch, state}, params) => {
  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(GET_DISTRICT_TO, state.districtsByCityCode[params.city_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_TO, response.data)
        if (params.city_code) {
          commit(SET_LOADED_DISTRICT_BY_CITY_CODE, {city_code: params.city_code, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_TO, [])
      }
    })
  }
}

const getAllDistrictFrom = ({commit, dispatch, state}, params) => {
  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(GET_DISTRICT_FROM, state.districtsByCityCode[params.city_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_FROM, response.data)
        if (params.city_code) {
          commit(SET_LOADED_DISTRICT_BY_CITY_CODE, {city_code: params.city_code, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_FROM, [])
      }
    })
  }
}

export default{
  getAllDistrict,
  getAllDistrictTo,
  getAllDistrictFrom
}



// WEBPACK FOOTER //
// ./src/components/district/store/actions.js